import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Alert, Modal, Button, Spinner, Table, Nav, Tab } from 'react-bootstrap';
import { PageStatus } from 'enums';
import { Show } from 'Layout';
import { AuthAPI } from "../../API";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from "react-redux";
import GridContainer from "../Grid/GridContainer";
import CardHeader from "../Card/CardHeader";
import moment from "moment/moment";
import { Confirmation } from "../../Shared/Confirmation";

function PreScreen() {

  const { role, selectedCountry, userId } = useSelector((state: any) => state.adminUser.adminUser);

  // Mirrors the backend edit/delete guard: admins can modify any custom
  // question, everyone else only their own (legacy NULL-creator rows are
  // admin-only).
  const canModifyCustomQuestion = (question: any) =>
    role === "admin" || role === "super_admin" || (!!question.createdby && question.createdby === userId);

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    appBar: {
      marginBottom: theme.spacing(3),
    },
    content: {
      padding: theme.spacing(3),
      textAlign: 'left',
    },
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
      alignItems: 'center',
    },
    logo: {
      width: '100%',
      maxWidth: '400px', // Adjust the maximum width as needed
    },
    grow: {
      flexGrow: 1,
    },
  }));

  const MODAL_TYPES = {
    NONE: 'NONE',
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    DETAILS: 'DETAILS',
    QUESTION: 'QUESTION'
  };

  const [formType, setFormType] = useState(MODAL_TYPES.NONE);
  const [status, setStatus] = useState(PageStatus.None);
  const [error, setError] = useState(null);
  const [formState, setFormState] = useState({});
  const [preScreenApiData, setPreScreenApiData] = useState([]);
  const [questionName, setQuestionName] = useState('');
  const [modalHeader, setModalHeader] = useState("Add");
  const [id, setId] = useState('');
  const [answersFields, setAnswersFields] = useState([]);
  const [updateAnsVal, setUpdateAnsVal] = useState(false);
  const [origionalApiResponse, setOrigionalApiResponse] = useState([]);
  const [selectedAnswer, setSelectedAnswer] = useState([]);
  // Profile is the default tab — far more rows live there (~180+) than in the
  // per-PM custom-questions list, so most PMs land on the more useful view.
  const [activeTab, setActiveTab] = useState<'profile' | 'custom'>('profile');

  const handleOpenCreateModal = () => { setFormType(MODAL_TYPES.CREATE); setModalHeader("Add"); setId(''); };

  const fetchList = async () => {
    setStatus(PageStatus.Loading);
    try {
      const responseData: any = await AuthAPI.getAllQuestions({});
      // Sectioning into Profile / Custom happens in render; no pre-filter here.
      setPreScreenApiData(responseData);
      setOrigionalApiResponse(responseData);
      setStatus(PageStatus.Loaded);
    } catch (err) {
      setStatus(PageStatus.Loaded);
      setError(err.message || "Failed, Try again!");
    }
  };

  const onCloseModalFunc = () => { setFormType(MODAL_TYPES.NONE); setFormState({}); setError(null); setAnswersFields([]); setStatus(PageStatus.None); setUpdateAnsVal(false); setSelectedAnswer([]); };

  const onFormSubmit = async (event) => {
    event.preventDefault();
    try {
      let submitingData = { ...formState, answer: answersFields };
      let apiRespo: any;
      if (id) {
        apiRespo = await AuthAPI.updateSurveyQuestions({ id, ...submitingData });
      } else {
        apiRespo = await AuthAPI.SurveyQuestions(submitingData);
      }
      setStatus(PageStatus.Submitting);
      const responseData: any = apiRespo;
      if (responseData.status == 0) { alert(responseData.message); }
      setStatus(PageStatus.Submitted);
      setFormType(MODAL_TYPES.NONE);
      setFormState({});
      setAnswersFields([]);
      fetchList();
    } catch (err) {
      setError(err.message);
      setStatus(PageStatus.Error);
    }
  }

  const onFormUpdate = async (event) => {
    try {
      event.preventDefault();
      if (selectedAnswer.length < 1) {
        alert("Please choose answer first");
        return;
      }
      let answerSettingPayload = { "questionId": id, "answerID": selectedAnswer };
      await AuthAPI.updateSurveyquestionanswer(answerSettingPayload);
      alert("Answer updated successfully.");
      onCloseModalFunc();
      fetchList();
    } catch (err) {
      setError("Failed, Try again!");
      setStatus(PageStatus.Error);
    }
  }

  const handleChange = (e) => {
    let { name, value } = e.target;
    setFormState((prev) => ({
      ...prev, [name]: value
    }));
    if (name !== "question") {
      if (name == "questionType" && value == "Range") {
        setAnswersFields([{ "lable": "Select Value", "name": "Range", "fromValue": "", "toValue": "" }]);
      } else {
        setAnswersFields([{ "lable": value, "name": value, "value": "" }]);
      }
    }
  };

  const addMoreRow = (name, indx, type) => {
    if (type == "add") {
      if (!answersFields[indx].value && name != "Select Value") {
        alert("please enter answer.");
        return;
      }
      if ((!answersFields[indx].toValue || !answersFields[indx].fromValue) && name == "Select Value") {
        alert("please enter range values.");
        return;
      }
      let newObj = name != "Select Value" ? { "lable": name, "name": name, "value": "" } : { "lable": "Select Value", "name": "Range", "fromValue": "", "toValue": "" };
      setAnswersFields((prevVal) => [
        ...prevVal,
        newObj
      ]);
    } else {
      setAnswersFields((prevVal) => {
        let updatedAnswers = [...prevVal];
        let newArr = updatedAnswers.filter((e, i) => i !== indx);
        return newArr;
      });
    }
  }

  const setInputValueInArr = (lable, evnt, indx, field) => {
    setAnswersFields((prevVal) => {
      let updatedAnswers = [...prevVal];
      let newArr = updatedAnswers.map((e, i) => {
        if (i == indx) {
          return { ...e, [field]: evnt.target.value };
        } else {
          return e;
        }
      });
      return newArr;
    });
  };

  const checkValidationNumber = (evntVal, indxx, fieldName) => {
    setAnswersFields((prevVal) => {
      let updatedAnswers = [...prevVal];
      if ((answersFields[indxx].fromValue != "") && (answersFields[indxx].toValue != "") && (parseInt(answersFields[indxx].fromValue) >= parseInt(answersFields[indxx].toValue))) {
        alert("'From' value can't be equal or greater than 'To' value.");
        updatedAnswers[indxx][fieldName] = "";
      }
      if ((answersFields[indxx][fieldName] != "") && answersFields.length > 1) {
        for (let elemIndxx = 0; elemIndxx < answersFields.length; elemIndxx++) {
          if (elemIndxx != indxx && (parseInt(answersFields[indxx][fieldName]) <= parseInt(answersFields[elemIndxx].toValue) && parseInt(answersFields[indxx][fieldName]) >= parseInt(answersFields[elemIndxx].fromValue))) {
            alert(`${updatedAnswers[indxx][fieldName]} is included in row number ${elemIndxx + 1}.`);
            updatedAnswers[indxx][fieldName] = "";
            break;
          }
          if ((elemIndxx != indxx) && (answersFields[indxx].fromValue != "") && (answersFields[indxx].toValue != "") && ((parseInt(answersFields[indxx].fromValue) < parseInt(answersFields[elemIndxx].toValue)) && (parseInt(answersFields[indxx].fromValue) < parseInt(answersFields[elemIndxx].fromValue))) && ((parseInt(answersFields[indxx].toValue) > parseInt(answersFields[elemIndxx].toValue)) && (parseInt(answersFields[indxx].toValue) > parseInt(answersFields[elemIndxx].fromValue)))) {
            alert(`Row number ${elemIndxx + 1} is included in current range.`);
            updatedAnswers[indxx][fieldName] = "";
            break;
          }
        }
      }
      return updatedAnswers;
    });
  }

  const editPreScreenQuestionDetails = (e, elem) => {
    e.stopPropagation();
    setId(elem.id);
    setFormType(MODAL_TYPES.CREATE);
    setModalHeader("Update");
    let answersValue = elem.questionType != "Range" ? elem.answer.map((e) => { return { "lable": elem.questionType, "name": elem.questionType, "value": e } }) : elem.answer.map((e) => { return { "lable": "Select Value", "name": "Range", "fromValue": e.fromValue, "toValue": e.toValue } });
    setFormState({ "question": elem.question, "questionType": elem.questionType, "answer": answersValue, "selectedAnsArr": [], });
    setAnswersFields(answersValue);
  }

  const deletePreScreenQuestionDetails = async (e, elem) => {
    try {
      await AuthAPI.deleteQuestion({ "id": elem.id });
      alert("Question deleted successfully");
      fetchList();
    } catch (error) {
      setError("Failed, Try again!");
      setStatus(PageStatus.Error);
    }
  }

  const handleAnswerChange = (event, ansVal, type) => {
    setSelectedAnswer((prevSelectedAnswer) => {
      if (type == "checkbox") {
        let newArr = event.target.checked ? [...prevSelectedAnswer, ansVal] : [...prevSelectedAnswer].filter(e => e != ansVal);
        return newArr;
      } else {
        let newArr = [...prevSelectedAnswer, ansVal].filter(e => e == ansVal && e != "");
        return newArr;
      }
    });
  };

  useEffect(() => {
    if (updateAnsVal) { setFormType(MODAL_TYPES.UPDATE); }
  }, [updateAnsVal]);

  useEffect(() => { fetchList(); }, [selectedCountry]);

  const setQuestionNameFunc = (evt) => { setQuestionName(evt.target.value); }

  const clearFilters = () => { setQuestionName((prevVal) => { fetchList(); return "" }); }

  useEffect(() => {
    if (questionName) {
      const newArr = origionalApiResponse.filter((ele: any) => ele.question.toLowerCase().includes(questionName.toLowerCase()));
      setPreScreenApiData(newArr);
    } else {
      setPreScreenApiData(origionalApiResponse);
    }
  }, [origionalApiResponse, questionName])

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Modal
        centered
        size="lg"
        backdrop="static"
        onHide={onCloseModalFunc}
        show={formType == MODAL_TYPES.CREATE}
        style={{ zIndex: 1201 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>  {modalHeader} PreScreen Question </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>
          <Show when={status === PageStatus.Loading}>
            <div className="d-flex justify-content-center w-100 p-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </Show>
          <Alert variant="danger" show={status === PageStatus.Error}>  {error}  </Alert>
          <form onSubmit={onFormSubmit} >
            <div className="row mt-2">
              <div className="col">
                <label htmlFor="titleEng">  Question*  </label>
                <input
                  className="form-control"
                  name="question"
                  onChange={handleChange}
                  value={formState.question || ""}
                  placeholder="Enter question"
                  required
                />
              </div>
              <div className="col">
                <label htmlFor="titleEng">  Question Field Type*  </label>
                <select
                  className="form-control"
                  name="questionType"
                  onChange={handleChange}
                  value={formState.questionType || ""}
                  disabled={id != ""}
                  required
                >
                  <option value="">Select type</option>
                  <option value="Range">Range</option>
                  {/* <option value="Zone">Zone</option> */}
                  {/* <option value="Zipcode">ZipCode</option> */}
                  <option value="Dropdown">Dropdown</option>
                  <option value="Radio">Radio</option>
                  <option value="Checkbox">CheckBox</option>
                  <option value="MultiSelectDropdown">MultiSelectDropdown</option>
                </select>
              </div>
            </div>

            {answersFields?.map((ele, index) => (
              ele.name == "Range" ? (<div className="col p-0" key={`abcd` + index}>
                {/* <div className="col"> */}
                <div className="input-group mt-3">
                  <input
                    className="form-control mx-1"
                    name={ele.name}
                    onChange={(e) => setInputValueInArr(ele.lable, e, index, "fromValue")}
                    onBlur={(e) => checkValidationNumber(e, index, "fromValue")}
                    value={ele.fromValue}
                    type='number'
                    placeholder={`From`}
                    required
                  />
                  <input
                    className="form-control mx-1"
                    name={ele.name}
                    onChange={(e) => setInputValueInArr(ele.lable, e, index, "toValue")}
                    onBlur={(e) => checkValidationNumber(e, index, "toValue")}
                    value={ele.toValue}
                    type='number'
                    placeholder={`To`}
                    required
                  />
                  {answersFields.length > 0 && index == answersFields.length - 1 ? (
                    <button
                      type='button'
                      onClick={(e) => addMoreRow(ele.lable, index, "add")}
                      className='bg-transparent'
                    >
                      <em
                        className="fa fa-plus text-success fa-lg cursor-pointer input-group-text"
                        title="Add more"
                      />
                    </button>
                  ) : null}
                  {answersFields.length > 1 ? (
                    <button
                      type='button'
                      onClick={() => addMoreRow(ele.lable, index, "dlt")}
                      className='bg-transparent'
                    >
                      <em
                        className="fa fa-trash text-danger fa-lg cursor-pointer input-group-text"
                        title="Delete row"
                      />
                    </button>
                  ) : null}
                </div>
                {/* </div> */}
              </div>) :
                (
                  <div className="col p-0" key={`abcdef` + index}>
                    <label htmlFor="body">Answer {answersFields.length > 1 ? index + 1 : ""}*</label>
                    <div className="input-group">
                      <input
                        className="form-control"
                        type="text"
                        value={ele.value}
                        name=""
                        id=""
                        onChange={(e) => setInputValueInArr(ele.lable, e, index, "value")}
                        placeholder={`Enter answer ${answersFields.length > 1 ? index + 1 : ""}`}
                        required
                      />
                      {answersFields.length > 0 && index == answersFields.length - 1 ? (
                        <button
                          type='button'
                          className='bg-transparent'
                          onClick={(e) => addMoreRow(ele.lable, index, "add")}
                        >
                          <em
                            className="fa fa-plus text-success fa-lg cursor-pointer input-group-text"
                            title="Add more"
                          />
                        </button>
                      ) : null}
                      {answersFields.length > 1 ? (
                        <button
                          type='button'
                          className='bg-transparent'
                          onClick={() => addMoreRow(ele.lable, index, "dlt")}
                        >
                          <em
                            className="fa fa-trash text-danger fa-lg cursor-pointer input-group-text"
                            title="Delete row"
                          />
                        </button>
                      ) : null}
                    </div>

                  </div>
                )
            ))}

            <Alert variant="danger" show={status === PageStatus.Error} className="mt-2">
              {error}
            </Alert>

            <div className="d-flex align-items-center mt-2">
              <button
                type="submit"
                className="btn btn-primary mr-3"
              >
                Submit
              </button>

              <Show when={status === PageStatus.Submitting}>
                <Spinner animation="border" variant="primary" />
              </Show>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal
        centered
        size="lg"
        backdrop="static"
        onHide={onCloseModalFunc}
        show={formType == MODAL_TYPES.UPDATE}
        style={{ zIndex: 1201 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add PreScreen Answer </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>
          <Show when={status === PageStatus.Loading}>
            <div className="d-flex justify-content-center w-100 p-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </Show>
          <Alert variant="danger" show={status === PageStatus.Error}>  {error}  </Alert>
          {formState?.question && (
            <form onSubmit={onFormUpdate}>
              <div className="row mt-2">
                <div className="col">
                  <lable>{formState?.question}</lable>
                  {formState?.answer?.map((e, index) => {
                    if (e.name === "Radio") {
                      return (
                        <div className="custom-control custom-radio" key={"formState" + index}>
                          <input
                            type="radio"
                            id={`prescreen-${index}`}
                            name={`prescreen-${index}`}
                            checked={selectedAnswer?.includes(e.value) || formState?.selectedAnsArr?.includes(e.value)}
                            className="custom-control-input"
                            onChange={(evt) => handleAnswerChange(evt, e.value, "radio")}
                          />
                          <label className="custom-control-label" htmlFor={`prescreen-${index}`}><span className='text-lg'>{e.value}</span></label>
                        </div>
                      )
                    } else if (e.name === "Checkbox" || e.name === "checkbox") {
                      return (
                        <div className="col ml-2" key={"checkBox" + index}>
                          <input
                            type="checkbox"
                            id={`prescreen-${index}`}
                            name={`prescreen-${index}`}
                            checked={selectedAnswer?.includes(e.value) || formState?.selectedAnsArr?.includes(e.value)}
                            className="custom-control-input"
                            onChange={(evt) => handleAnswerChange(evt, e.value, "checkbox")}
                          />
                          <label className="custom-control-label" htmlFor={`prescreen-${index}`}><span className='text-lg'>{e.value}</span></label>
                        </div>
                      )
                    } else {
                      return null;
                    }
                  })}

                  {
                    (formState?.questionType == "Range" || formState?.questionType == "Dropdown") && <div>
                      <select
                        name="rangeSelect"
                        id="rangeSelect"
                        className='form-control'
                        // value={(selectedAnswer.length > 0 ? selectedAnswer[0] : "")}
                        onChange={(evt) => handleAnswerChange(evt, evt.target.value, "Dropdown")}
                      >
                        <option value="">Select option</option>
                        {formState?.answer?.map((e, index) => (
                          <option selected={(selectedAnswer.length > 0 ? selectedAnswer[0] : "") || formState?.selectedAnsArr?.includes(e.value)} value={e.value} key={"formOpts" + index}>{e.value}</option>
                        ))}
                      </select>
                    </div>
                  }
                </div>
              </div>

              {/* Error message */}
              <Alert variant="danger" show={status === PageStatus.Error} className="mt-2">
                {error}
              </Alert>

              <div className="d-flex align-items-center mt-2">
                <button type="submit" className="btn btn-primary mr-3">
                  Submit
                </button>

                {/* Show spinner when submitting */}
                {status === PageStatus.Submitting && (
                  <Spinner animation="border" variant="primary" />
                )}
              </div>
            </form>
          )}

        </Modal.Body>
      </Modal>

      <GridContainer>
        <div className='w-100 mb-3'>
          <CardHeader color="primary">
            <div className="d-flex align-items-center justify-content-between">
              <h4>PreScreen Questions</h4>
            </div>
          </CardHeader>
        </div>
      </GridContainer>
      <div className="jumbotron bg-white p-3 border shadow-sm">
        <div className='mb-3'>Filter</div>
        <div className="row">
          <div className="col">
            <label htmlFor='questionName'>Question</label>
            <input
              type="text"
              className="form-control"
              placeholder="Search Question"
              name="questionName"
              value={questionName}
              onChange={(e) => { setQuestionNameFunc(e) }}
            />
          </div>
        </div>

        <div className="jumbotron bg-white p-1 mt-2 shadow-sm">
          <button type="button" className="btn btn-success" onClick={() => fetchList()}>Filter Questions</button>
          {/* <button type="button" className="btn btn-info ml-1" onClick={() => handleExport()}>Export</button> */}
          <button type="button" className="btn btn-danger ml-1" onClick={() => clearFilters()}>Clear Filter</button>
        </div>
      </div>
      <div className="jumbotron bg-white p-3 border shadow-sm">
        <Show when={status === PageStatus.Loading}>
          <div className="d-flex justify-content-center w-100 p-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Show>

        <Show when={status !== PageStatus.Loading}>
          <Tab.Container activeKey={activeTab} onSelect={(k: any) => setActiveTab(k)}>
            <Nav variant="tabs" style={{ borderBottom: '1px solid #dee2e6' }}>
              <Nav.Item>
                <Nav.Link eventKey="profile">Profile Questions</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="custom">Custom Questions</Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              {/* Profile Questions — shared library, no inline edit/delete here. */}
              <Tab.Pane eventKey="profile">
                <p style={{ fontSize: '0.85em', color: '#666', marginTop: 12 }}>
                  Shared question library, available to all PMs.
                </p>
                {(() => {
                  const profileItems = preScreenApiData.filter((q: any) => q.type === 'auto');
                  if (profileItems.length === 0) {
                    return <Alert variant="info">No profile questions available.</Alert>;
                  }
                  return (
                    <Table responsive size="sm" bordered>
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Question</th>
                          <th>CreatedAt</th>
                          <th>UpdatedAt</th>
                        </tr>
                      </thead>
                      <tbody>
                        {profileItems.map((preScreen: any, index: number) => (
                          <tr key={preScreen.id}>
                            <td>{index + 1}</td>
                            <td>
                              <button
                                className="text-primary bg-transparent"
                                onKeyPress={() => null}
                                dangerouslySetInnerHTML={{ __html: preScreen.question || 'Title' }}
                              ></button>
                            </td>
                            <td>{moment(preScreen.createdAt).format('MM/DD/YYYY HH:mm A')}</td>
                            <td>{moment(preScreen.updatedAt).format('MM/DD/YYYY HH:mm A')}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  );
                })()}
              </Tab.Pane>

              {/* Custom Questions — per-PM scoped (creator + country). Create
                  button lives in this tab only because the create flow only
                  adds custom questions. */}
              <Tab.Pane eventKey="custom">
                <div className="d-flex align-items-center justify-content-between" style={{ marginTop: 12 }}>
                  <p style={{ fontSize: '0.85em', color: '#666', marginBottom: 0 }}>
                    Per-PM custom questions. Only the creator and admins can edit these.
                  </p>
                  {role && role !== 'sales' && (
                    <Button
                      onClick={handleOpenCreateModal}
                      variant="primary"
                      size="sm"
                    >
                      <FontAwesomeIcon icon={['fas', 'plus']} className="mr-2" />
                      Create
                    </Button>
                  )}
                </div>
                <div style={{ marginTop: 12 }}>
                  {(() => {
                    const customItems = preScreenApiData.filter((q: any) => q.type === 'new');
                    if (customItems.length === 0) {
                      return <Alert variant="info">No custom questions yet. Click Create to add one.</Alert>;
                    }
                    return (
                      <Table responsive size="sm" bordered>
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Question</th>
                            <th>Question Type</th>
                            <th>CreatedAt</th>
                            <th>UpdatedAt</th>
                            {role && role !== 'sales' && <th>Action</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {customItems.map((preScreen: any, index: number) => (
                            <tr key={preScreen.id}>
                              <td>{index + 1}</td>
                              <td>
                                <button
                                  className="text-primary bg-transparent"
                                  onKeyPress={() => null}
                                  dangerouslySetInnerHTML={{ __html: preScreen.question || 'Title' }}
                                ></button>
                              </td>
                              <td>{preScreen.questionType}</td>
                              <td>{moment(preScreen.createdAt).format('MM/DD/YYYY HH:mm A')}</td>
                              <td>{moment(preScreen.updatedAt).format('MM/DD/YYYY HH:mm A')}</td>
                              {role && role !== 'sales' && (
                                <td>
                                  {canModifyCustomQuestion(preScreen) ? (
                                  <div className='d-flex text-center'>
                                    <div className='mx-1'>
                                      <button
                                        type='button'
                                        className='bg-transparent'
                                        onClick={(event) => editPreScreenQuestionDetails(event, preScreen)}
                                      >
                                        <i className='fa fa-edit text-success' title="Edit details"></i></button>
                                    </div>
                                    <div className='mx-1'>
                                      <Confirmation onAction={(event) => deletePreScreenQuestionDetails(event, preScreen)} body="Do you want to delete this question ?">
                                        <i className='fa fa-trash text-danger' title="Delete question"></i>
                                      </Confirmation>
                                    </div>
                                  </div>
                                  ) : '-'}
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    );
                  })()}
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Show>
      </div>
    </div>
  );
}

export default PreScreen;
